import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoSinglePreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const {
  reason,
  request,
  addressFurigana,
  checkValid,
  formLib,
  scaleStyle,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  tel,
  age,
  formatedCreateDate,
  isMale,
  isFemale,
  isGenderDisplay,
  eduJobHistoryTable,
  licenseHistoryTable,
  optionItems
} = useRirekishoPreview(props, {
  maxEduJobRows: 10,
  maxLicenseRows: 4,
  textareaMaxHeights: { reason: 60, request: 72 },
  optionItems: { commuteDescription: false }
})

expose({
  checkValid,
  errorMessages,
  optionItems,
  reason,
  request,
  addressFurigana
})

return { __sfc: true,props, reason, request, addressFurigana, checkValid, formLib, scaleStyle, goCardTo, highLightClass, classObject, errorMessages, tel, age, formatedCreateDate, isMale, isFemale, isGenderDisplay, eduJobHistoryTable, licenseHistoryTable, optionItems }
}

})